import { computed } from 'vue'
import { translate } from 'src/layouts/core-layout/_functions/translate'
import { getSiteLogoPd, type SiteLogo } from 'src/layouts/core-layout/components/CoreHeader/components/mobile/TheHeader/constants'
import type useTheHeaderSite from 'src/layouts/core-layout/components/CoreHeader/components/mobile/TheHeader/composables/useTheHeaderSite'

type HeaderSite = ReturnType<typeof useTheHeaderSite>

export default function useTheHeaderSiteLogo(site: HeaderSite) {
  const {
    context,
    isProbolezny,
    isProtabletky,
    isConsult,
  } = site

  const siteLogo = computed<SiteLogo>(() => {
    const country = context.request?.country
    const mediaPrefix = context.global?.static?.media || ''

    if (country && !country.is_russia && country.site_logo) {
      return {
        src: new URL(country.site_logo, mediaPrefix).href,
        alt: translate('Ydoc'),
      }
    }

    if (isProbolezny.value) {
      return {
        src: '/static/_v1/pb/logos/ui-kit/probolezny-logo.svg',
        alt: translate('ПроБолезни'),
      }
    }

    if (isProtabletky.value) {
      return {
        src: '/static/_v1/pt/logos/ui-kit/protabletky-logo.svg',
        alt: translate('ПроТаблетки'),
      }
    }

    if (isConsult.value) {
      return {
        src: '/static/_v1/mo/logos/ui-kit/medotvet-logo.svg',
        alt: translate('МедОтвет'),
      }
    }

    return {
      ...getSiteLogoPd(),
      alt: translate('ПроДокторов'),
    }
  })

  return {
    siteLogo,
  }
}
